import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbDropdownModule, NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  SearchBarModule,
  FormValidationModule,
  SwitcherModule,
  GlobalErrorHandler,
} from '@tablesready/common-ui';
import { CheckboxGroupModule } from '@tablesready/checkbox-group';
import { BadgeModule } from '@tablesready/frontend-badge';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { CopySettingsModalComponent } from './modals';
import { LocationsComponent } from './locations.component';
import { LocationsRoutingModule } from './locations.routing.module';
import { LocationsFilterService } from './locations.filter.service';
import { LocationsListService } from './locations-list.service';
import { FrontendGooglePlacesModule } from '@tablesready/frontend-google-places';
import { LocationNameColumnModule, SmsUsageModule } from '../../../components';
import { ModalsModule } from '../../../modals';

@NgModule({
  declarations: [LocationsComponent, CopySettingsModalComponent],
  imports: [
    CommonModule,
    ModalsModule,
    FormsModule,
    ReactiveFormsModule,
    FrontendIconsModule,
    NgbModule,
    FormValidationModule,
    SwitcherModule,
    LocationsRoutingModule,
    FrontendGooglePlacesModule,
    BadgeModule,
    SearchBarModule,
    NgbAlertModule,
    NgbDropdownModule,
    SmsUsageModule,
    LocationNameColumnModule,
    CheckboxGroupModule,
    FrontendModalModule,
    FrontendPullRefreshModule,
    FrontendDropdownModule,
  ],
  providers: [
    LocationsListService,
    LocationsFilterService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
})
export class LocationsModule {}
